import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const RESTRICTION_SILENCES_QUERY_KEY = 'restriction-silences';

export const getRestrictionSilencesQueryKey = ({
  clusterId,
}: {
  clusterId: string;
}) => [RESTRICTION_SILENCES_QUERY_KEY, clusterId] as const;

type RestrictionSilencesParams = {
  organizationId: string;
  clusterId: string;
  enabled?: boolean;
};

const getRestrictionSilencesQueryOptions = ({
  organizationId,
  clusterId,
  enabled = true,
}: RestrictionSilencesParams) =>
  queryOptions({
    queryKey: getRestrictionSilencesQueryKey({ clusterId }),
    queryFn: async () => {
      const { data } = await apiClient.costReport.listRestrictionSilences({
        organizationId,
        clusterId,
      });
      return data?.silences ?? [];
    },
    enabled: makeIsEnabled(enabled, !!organizationId, !!clusterId),
  });

export const useRestrictionSilencesQuery = (
  params: RestrictionSilencesParams
) => useQuery(getRestrictionSilencesQueryOptions(params));
